import initialState from './initialState';
import {
  GENERATE_PDF,
  GENERATE_PDF_LOADING,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_ERROR,
  GENERATE_PDF_DONE,
  CLEAR_PDF_INFO
} from '../actions/actionTypes';
import Logger from '../util/Logger';

// Create your Reducer here...
const reducerGeneratePdf = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_PDF_LOADING:
      Logger.info('pdf: action: ', action);
      return {
        ...state,
        loading: true,
        error: null,
        pdfDownloadUrl: null
      };
    case GENERATE_PDF_SUCCESS:
      Logger.info('pdf: action: ', action);
      return {
        ...state,
        error: null,
        pdfDownloadUrl: action.pdfDownloadUrl

      };
    case GENERATE_PDF_ERROR:
      Logger.info('pdf: action: ', action);
      return {
        ...state,
        error: action.error,
        pdfDownloadUrl: null
      };
    case GENERATE_PDF_DONE:
      Logger.info('pdf: action: ', action);
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};
const reducerClearPdfInfo = (state = initialState, action) => {
  Logger.info('pdf: action: ', action);
  switch (action.type) {
    case CLEAR_PDF_INFO:
      Logger.info('pdf: action: ', action);
      return {
        ...state,
        loading: null,
        error: null,
        pdfDownloadUrl: null
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(GENERATE_PDF)) {
    return reducerGeneratePdf(state, action);
  } else if (action.type.startsWith(CLEAR_PDF_INFO)) {
    return reducerClearPdfInfo(state, action);
  } else {
    return state;
  }
};
